export class ArrayUtils {
  public static isArray(obj: any): boolean {
    return Array.isArray(obj);
  }

  public static getMaxValueOfArray(arr: number[]): number {
    return Math.max.apply(Math, arr || []) || 0;
  }
  public static isSameArray(arr1: any[], arr2: any[]): boolean {
    if (!arr1?.length && !arr2?.length) {
      return true;
    }

    if (!arr1?.length && arr2?.length) {
      return false;
    }

    if (arr1?.length && !arr2?.length) {
      return false;
    }

    if (arr1?.length !== arr2?.length) {
      return false;
    }

    const sortedArr1 = [...arr1].sort();
    const sortedArr2 = [...arr2].sort();

    for (let i = 0; i < sortedArr1.length; i++) {
      if (sortedArr1[i] !== sortedArr2[i]) {
        return false;
      }
    }

    return true;
  }
}
